/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApprovalMode {
    AUTO_APPROVE = 'AUTO_APPROVE',
    PARALLEL = 'PARALLEL',
    SEQUENTIAL = 'SEQUENTIAL',
}
